export default class ShortenerDomain {
	constructor({
		name
	}) {
		this._name = name;
	}

	getName() {
		return this._name;
	}

	getKey() {
		return this._name;
	}
}
